module.exports = __webpack_public_path__ + "static/footer-musicSupport-8f75754e3ce367e0005516dd2b2910c1.svg";